import { render, staticRenderFns } from "./WaybillTypeIndex.vue?vue&type=template&id=6e67fe50&scoped=true&"
import script from "./WaybillTypeIndex.vue?vue&type=script&lang=js&"
export * from "./WaybillTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67fe50",
  null
  
)

export default component.exports